import { CheckmarkIcon, PartiallyCheckedMinus } from "assets/icons";
import cn from "classnames";
import { ForwardedRef, forwardRef } from "react";
import { Icon } from "ui";

import { CheckboxProps } from "./Checkbox.types";

import styles from "./Checkbox.module.scss";

const Checkbox = forwardRef(
  (
    {
      className,
      label,
      disabled,
      checked,
      partiallyChecked,
      ...props
    }: CheckboxProps,
    ref: ForwardedRef<HTMLInputElement>
  ) => {
    return (
      <label
        className={cn(
          styles.checkbox,
          {
            [styles["checkbox--disabled"]]: disabled
          },
          className
        )}
      >
        <input
          ref={ref}
          checked={checked}
          disabled={disabled}
          type="checkbox"
          className={styles.checkbox__input}
          {...props}
        />

        <div
          className={cn(styles.checkbox__icon, {
            [styles["checkbox__icon--checked"]]: checked
          })}
        >
          {checked ? (
            partiallyChecked ? (
              <Icon as={PartiallyCheckedMinus} />
            ) : (
              <Icon as={CheckmarkIcon} width={10} height={8} color="#fff" />
            )
          ) : null}
        </div>

        {label ? <p className={styles.checkbox__label}>{label}</p> : null}
      </label>
    );
  }
);

Checkbox.displayName = "Checkbox";

export default Checkbox;
